import { render, staticRenderFns } from "./dialRecord.vue?vue&type=template&id=2e05c982"
import script from "./dialRecord.vue?vue&type=script&lang=js"
export * from "./dialRecord.vue?vue&type=script&lang=js"
import style0 from "./dialRecord.vue?vue&type=style&index=0&id=2e05c982&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports